import { StrictMode } from "react";
import { BrowserRouter } from "react-router";
import { Application } from "./Application.tsx";

async function mount(ontoElementWithId: string): Promise<void> {
  const mountPoint = document.getElementById(ontoElementWithId);
  if (!mountPoint) {
    throw new Error(
      `Cannot mount Heliopolis application: Element with id ${ontoElementWithId} not found!`,
    );
  }

  const { createRoot } = await import("react-dom/client");

  return createRoot(mountPoint).render(
    <StrictMode>
      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </StrictMode>,
  );
}

mount("root");
